import {CompanyInput, CompanyOption} from '@/components/forms/input/company';
import {UserInfosFormValues} from '@/redux-store/slices/user-infos';
import {CompanyInUserInfos} from '@/types/company';
import {useCallback} from 'react';
import {useTranslation} from 'react-i18next';

interface CompanyFilterProps {
  selectedCompanies: string[] | null;
  onCompaniesChange: (selectedCompany: string[]) => void;
  userData: UserInfosFormValues;
}

const CompanyFilter: React.FC<CompanyFilterProps> = ({
  selectedCompanies,
  onCompaniesChange,
  userData
}) => {
  const {t} = useTranslation();

  const availableCompanies = userData.companies;

  const selectedCompanyValues =
    selectedCompanies && availableCompanies
      ? selectedCompanies
          .map((id) =>
            availableCompanies.find((company) => company.id._id === id)
          )
          .filter(
            (company): company is CompanyInUserInfos => company !== undefined
          )
      : null;

  const handleCompanyChange = useCallback(
    (
      event: React.SyntheticEvent,
      newValue: CompanyOption | CompanyOption[] | null
    ) => {
      if (Array.isArray(newValue)) {
        if (newValue.some((option) => option.id._id === null)) {
          onCompaniesChange([]);
        } else {
          const selectedIds = newValue
            .map((option) => option.id._id)
            .filter((id): id is string => id !== null);
          onCompaniesChange(selectedIds);
        }
      } else if (newValue) {
        if (newValue.id._id !== null) {
          onCompaniesChange([newValue.id._id]);
        } else {
          onCompaniesChange([]);
        }
      } else {
        onCompaniesChange([]);
      }
    },
    [onCompaniesChange]
  );

  if (!availableCompanies || availableCompanies.length === 0) {
    return null;
  }

  return (
    <CompanyInput
      companies={availableCompanies}
      value={selectedCompanyValues}
      onChange={handleCompanyChange}
      label={t('companies')}
      multiple
    />
  );
};

export default CompanyFilter;
